<template>
	<div>

		<div class="row">
			<div class="col-sm-3" v-for="(hint, hindex) in hints">
				<div class="puzzle-item">
					<figure>
						<img :src="hint.image_url">
					</figure>
					<div class="puzzle-title">
						{{ hint.title }}
					</div>
					<div v-for="(items, hitems) in hint.items">
						<div v-for="(item, hitem) in items">
							<div class="read-more" @click="popupOpen(hint, hitems, true)" v-if="item.type == 'indication'">
								{{ item.title }}
								<i class="icon-arrow-right"></i>
							</div>
							<div class="read-more" @click="popupOpen(hint, hitems, false)" v-if="item.type == 'solution'">
								{{ item.title }}
								<i class="icon-arrow-right"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<transition name="puzzle-fade">
			<div class="puzzle-cover" v-show="open" @click.self="popupClose">
				<div class="puzzle-center" @click.self="popupClose">
					<div class="puzzle-popup-dialog">
						<div class="puzzle-popup-close" @click="popupClose">
							&times;
						</div>
						<div class="row">
							<div class="puzzle-popup-image col-sm-5">
								<img :src="currentItem.image_url">
							</div>
							<div class="col-sm-7">
								<div class="puzzle-popup-title">
									{{ currentItem.title }}
								</div>
								<div class="puzzle-popup-body" v-html="currentItem.body"></div>
							</div>
						</div>
						<div class="puzzle-popup-navigation row" v-show="isIndication">
							<div class="offset-sm-5 col-sm-7">
								<div class="row">
									<nav class="nav-puzzle">
										<div class="puzzle-popup-nav puzzle-left" @click="previous">
											<i class="icon-arrow-left"></i>
											Vorige <span class="aanwijzing aanwijzing-prev">aanwijzing</span>
										</div>
										<div class="puzzle-popup-nav puzzle-right" @click="next">
											Volgende <span class="aanwijzing aanwijzing-next">aanwijzing</span>
											<i class="icon-arrow-right"></i>
										</div>
									</nav>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>

	</div>
</template>

<script>
import {forEach} from "lodash-es";

export default {
	props: {
		hints: {
			type: Array,
			default: () => [],
		}
	},
	data() {
		return {
			open: false,
			currentHint: [],
			currentItemIndex: null,
			currentItem: {
				image: '',
				type: '',
				image_url: '',
				title: '',
				body: '',
			},
			isIndication: true,
		}
	},
	methods: {
		popupOpen(hint, itemIndex, indication) {
			this.isIndication = indication;
			this.currentHint = hint;
			this.currentItemIndex = itemIndex;
			this.currentItem = hint.items[itemIndex].item;
			this.open = true;
			$('body').addClass('puzzle-open');
		},

		popupClose() {
			this.open = false;

			// reset the content. This also stops all players
			this.currentItem = {
				image: '',
				type: '',
				image_url: '',
				title: '',
				body: '',
			};

			$('body').removeClass('puzzle-open');
		},

		next() {
			let hasFound = false;

			forEach(this.currentHint.items, (value, key) => {
				if(key > this.currentItemIndex && value.item.type != 'solution') {
					this.currentItemIndex = key;
					this.currentItem = this.currentHint.items[key].item;
					hasFound = true;
					return false;
				}
			});

			// if no suitable item has been found, try again. But now without key restrictions
			if(!hasFound) {
				forEach(this.currentHint.items, (value, key) => {
					if(value.item.type != 'solution') {
						this.currentItemIndex = key;
						this.currentItem = this.currentHint.items[key].item;
						hasFound = true;
						return false;
					}
				});
			}
			this.$forceUpdate();
		},

		previous() {
			let hasFound = false;

			for (var i = this.currentHint.items.length - 1; i >= 0; i--) {
				if(i < this.currentItemIndex && this.currentHint.items[i].item.type != 'solution') {
					this.currentItemIndex = i;
					this.currentItem = this.currentHint.items[i].item;
					hasFound = true;
					break;
				}
			}

			// if no suitable item has been found, try again. But now without key restrictions
			if(!hasFound) {
				for (var i = this.currentHint.items.length - 1; i >= 0; i--) {
					if(this.currentHint.items[i].item.type != 'solution') {
						this.currentItemIndex = i;
						this.currentItem = this.currentHint.items[i].item;
						hasFound = true;
						break;
					}
				}
			}
			this.$forceUpdate();
		}
	},
	mounted() {

	}
}
</script>
